/**
 * The gallery's contents — GENERATED, do not edit by hand. The pixels are in `gallery.generated.ts`.
 *
 * ⚠️ IDS ONLY, SO THAT IMPORTING THE MATCHER DOES NOT IMPORT 300 kB OF BASE64. `placeholders.ts`
 * needs the list to score tags against and to know what exists; only the editor needs the pictures,
 * and it loads them on demand.
 */

export const GALLERY_IDS: string[] = [
  'coffee',
  'restaurant',
  'retail',
  'car',
  'tower',
  'diriyah',
  'greenery',
  'craft',
  'desert',
  'clinic',
  'bakery',
  'fitness',
  'school',
  'salon',
  'flowers',
  'property',
  'events',
  'construction',
]
